<div class="text-center" *hasPermission="permissionTypes.ModifyPlayerNumbers">
  <button mat-icon-button [matMenuTriggerFor]="menu">
    <mat-icon class="menu-button"
              data-testid="gold-rush-autoplay-settings-menu"
              matTooltipPosition="right"
              matTooltip="Open autoplay settings menu">
      more_horiz
    </mat-icon>
  </button>
</div>

<mat-menu #menu="matMenu">
  <button mat-menu-item
          data-testid="toggle-gold-rush-autoplay-button"
          (click)="onToggleAutoplay()">
    <mat-icon class="dark-grey menu-icon">
      {{ rowData?.Autoplay ? 'cancel' : 'play_arrow' }}
    </mat-icon>
    <span class="dark-grey menu-text">
      {{ rowData?.Autoplay ? 'Disable Autoplay' : 'Enable Autoplay' }}
    </span>
  </button>
</mat-menu>
